module.exports = __webpack_public_path__ + "static/darklight-10ae1ba8f6b5bee3b21c44acadf5c1e1.png";